var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMusicPlayAudio = function SvgIconMusicPlayAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "M69.633 17.266v37.667c0 6.6-5.367 11.967-11.967 11.967C51.1 66.9 45.7 61.533 45.7 54.933 45.7 48.366 51.1 43 57.666 43c2.8 0 5.3.966 7.334 2.566V25.733l-30.7 8.733v26.9c0 6.6-5.4 11.967-11.967 11.967-6.6 0-11.967-5.367-11.967-11.967 0-6.566 5.367-11.933 11.967-11.933 2.767 0 5.267.967 7.3 2.533V22.5c0-4.9 2.967-8.7 7.667-9.967l19.266-5.267c3.9-1.066 7.2-.7 9.534 1.1 2.366 1.767 3.533 4.767 3.533 8.9"
  })));
};
export default SvgIconMusicPlayAudio;